import AWSConciergeMagicMovieMachine, {
  Category,
  EventType,
  GetMovieRecommendationsRequest,
  PutMovieEventsRequest,
} from '@amzn/awsconcierge-magic-movie-machine-type-script-client';

import ServiceProvider from 'services/ServiceProvider';

export const getRecommendedMovies = async (userId: string, category: Category) => {
  try {
    const howserService: AWSConciergeMagicMovieMachine = ServiceProvider.getHowserService();
    const request: GetMovieRecommendationsRequest = {
      userId,
      category,
    };
    const movies = await howserService.getMovieRecommendations(request);
    return movies;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const putMovieRecommendations = async (userId: string, moviesList: any[]) => {
  try {
    const howserService: AWSConciergeMagicMovieMachine = ServiceProvider.getHowserService();
    const request: PutMovieEventsRequest = {
      userId,
      sessionId: userId,
      events: moviesList.map((movieId) => ({
        movieId: `ml_${movieId}`,
        eventType: EventType.click,
        sentAt: Date.now(),
      })),
    };
    return await howserService.putMovieEvents(request);
  } catch (e) {
    return Promise.reject(e);
  }
};
